import moment from 'moment';
import React, { memo, useMemo } from 'react';
/**
 *
 */
var SingleDateTab = function (_a) {
    var timestamp = _a.timestamp, monthlyView = _a.monthlyView;
    var date = useMemo(function () { return moment(timestamp); }, [timestamp]);
    var dayStr = date.format('ddd');
    var dateStr = date.format('D MMM');
    var monthStr = date.format('MMM');
    var yearStr = date.format('YYYY');
    var monthlyClass = monthlyView ? 'monthly' : '';
    return (React.createElement("span", { className: "date-tab-button-content" },
        React.createElement("span", { className: "date-tab-button-day " + monthlyClass }, monthlyView ? monthStr : dayStr),
        React.createElement("span", { className: "date-tab-button-date " + monthlyClass }, monthlyView ? yearStr : dateStr)));
};
SingleDateTab.defaultProps = {
    monthlyView: false,
};
export default memo(SingleDateTab);
